function stylesheet(useActualHostSelector, token) {
  var shadowSelector = token ? ("[" + token + "]") : "";
  var hostSelector = token ? ("[" + token + "-host]") : "";
  return ["lightning-button", shadowSelector, " {border-color: black;border-style: solid 3px;}.icon-color-blue-highlight", shadowSelector, " {--sds-c-button-color-background: blue;}.toolbarWrapper", shadowSelector, " {overflow: visible;}.display-none", shadowSelector, " {display: none;}"].join('');
}
export default [stylesheet];